import Breadcrumb from './../components/BreadCrumb';
import HeadingDetailsSection from './../sections/HeadingDetailsSection';
import ServiceSection from './../sections/ServiceSections';

function PrivacyPolicyScreen() {
  return (
    <>
        <HeadingDetailsSection heading='Privacy Policy'>
          <Breadcrumb screen='Privacy Policy'/>
        </HeadingDetailsSection>
        <ServiceSection/>
    </>
  );
}

export default PrivacyPolicyScreen;
